import {
  EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE,
  EDITING_DOCUMENTS_LIST_FETCH_FAILURE,
  EDITING_DOCUMENTS_LIST_FETCH_REQUEST,
} from '@app/store/actionTypes';
import { EditingDocumentsAction } from '@app/store/editingDocuments/actions';

type EditingDocumentsErrorWhileListFetchingState = string | null;

const initialState: EditingDocumentsErrorWhileListFetchingState = null;

export default function reducer(
  state: EditingDocumentsErrorWhileListFetchingState = initialState,
  action: EditingDocumentsAction
) {
  switch (action.type) {
    case EDITING_DOCUMENTS_DOMAIN_DATA_INITIALIZE:
      return initialState;
    case EDITING_DOCUMENTS_LIST_FETCH_REQUEST:
      return null;
    case EDITING_DOCUMENTS_LIST_FETCH_FAILURE:
      return action.payload.message;
    default:
      return state;
  }
}
